var React = require('react');

function VideoControlsShrinkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.25 9.75L14.25 3L21 9.75L14.25 9.75ZM9.75007 14.25L9.75007 21L3.00007 14.25L9.75007 14.25ZM14.25 21L14.25 14.25L21 14.25L14.25 21ZM9.75 9.75013L9.75 3.00013L3 9.75013L9.75 9.75013Z","fill":"currentColor"}));
}

VideoControlsShrinkInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = VideoControlsShrinkInline;

VideoControlsShrinkInline.default = VideoControlsShrinkInline;
